import React from 'react';

const Dashboard = () => {
  return <div>Dashboard</div>;
};

Dashboard.propTypes = {};

export default Dashboard;
